import { Directive, effect, inject, input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AppRole } from '@shared/auth/enums/app-role.enum';
import { RoleAccessService } from '@shared/auth/services/role-access.service';

@Directive({
  selector: '[appHasRole]',
  standalone: true
})
export class HasRoleDirective {
  readonly roles = input<AppRole | AppRole[] | null>(null, { alias: 'appHasRole' });

  private readonly templateRef = inject(TemplateRef<unknown>);
  private readonly viewContainer = inject(ViewContainerRef);
  private readonly roleAccessService = inject(RoleAccessService);

  constructor() {
    effect(() => {
      this.updateView(this.roles());
    });
  }

  private updateView(value: AppRole | AppRole[] | null): void {
    this.viewContainer.clear();

    if (!value) {
      return;
    }

    const roles = (Array.isArray(value) ? value : [value]).filter(Boolean);

    if (this.roleAccessService.hasAnyRole(roles)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
